import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SelectNoticeTypeMstModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'serviceTypeCd',
        'serviceTypeName',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          serviceTypeCd: 'サービスタイプID',
          serviceTypeName: 'サービスタイプ名',
        },
        columnsClasses: {
          checkbox: 'wp-3',
          serviceTypeCd: 'wp-5',
          serviceTypeName: '',
        },
        sortable: [
          'serviceTypeCd',
          'serviceTypeName',
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('サービスタイプ'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.selectServiceTypeModal.active,

      // form
      value: state => state.selectServiceTypeModal.value,

      // model
      serviceTypeModel: state => state.selectServiceTypeModal.serviceTypeModel,
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableConfirmButton () {
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectServiceTypeModal/loadModel',
      hide: 'selectServiceTypeModal/hide',
      setValue: 'selectServiceTypeModal/setValue',
      reset: 'selectServiceTypeModal/reset'
    }),

    init () {
      this.loading = true

      // storeをリセット
      // this.reset()

      // 選択済みサービス配信タイプUUIDをチェックリストに格納
      if (this.value &&
        this.value.length) {
        let data = $.extend(true, [], this.value.map(item => item.serviceTypeCd))
        this.$set(this, 'checkList', data)
      }

      //
      let serviceTypeParams = {}

      // データ読出し
      this.loadModel({
        serviceTypeParams: serviceTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.serviceTypeModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.serviceTypeCd
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    selectItem (props) {
      let data = this.checkList.length
        ? this.checkList.map(code => {
          return {
            serviceTypeCd: code,
            serviceTypeName: this.serviceTypeModel.filter(item => item.serviceTypeCd === code)[0].serviceTypeName
          }
        })
        : []
      // console.log(data)
      // 選択されたファイル情報をstoreに保持
      this.setValue(data)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}